import React from "react";
import { graphql } from "gatsby"
import Block from "../../Block";

class CoreSpacer extends Block {
  render() {
    return <br />;
  }
}

class CoreSpacerFactory {
  get type() {
    return "core/spacer";
  }

  create(props) {
    return <CoreSpacer {...props} />;
  }
}

export default CoreSpacerFactory;
